import { immer } from 'zustand/middleware/immer'

import { AvailableTimes } from '~/clients/optimus-client'

import { Slice } from '../store'

type State = {
    availableTimes: Record<number, AvailableTimes>
}

const initialState: State = {
    availableTimes: {},
}

type Actions = {
    actions: {
        setAvailableTimes: (availableTimes: Record<number, AvailableTimes>) => void
    }
}

export type OccupanciesSlice = {
    occupancies: State & Actions
}

export const createOccupanciesSlice: Slice<OccupanciesSlice> = immer(set => ({
    occupancies: {
        ...initialState,
        actions: {
            setAvailableTimes: (availableTimes: Record<number, AvailableTimes>) => {
                set(state => {
                    for (const [blockScheduleId, availableTime] of Object.entries(availableTimes)) {
                        if (state.occupancies.availableTimes[Number(blockScheduleId)] !== availableTime) {
                            state.occupancies.availableTimes[Number(blockScheduleId)] = availableTime
                        }
                    }
                })
            },
        },
    },
}))
